module.exports = __webpack_public_path__ + "img/oho-pro-checkout-watches.611492c0.png";